import { useCallback, useEffect, useState } from 'react';

const STORAGE_PREFIX = 'spassu-code:cockpit:metrics:';

export function useMetricsSectionPreference(scope?: string | null) {
  const [expanded, setExpanded] = useState(() => readPreference(scope));

  useEffect(() => setExpanded(readPreference(scope)), [scope]);

  const updateExpanded = useCallback(
    (next: boolean) => {
      setExpanded(next);
      if (!scope) return;
      try {
        window.localStorage.setItem(
          `${STORAGE_PREFIX}${scope}`,
          next ? 'expanded' : 'collapsed',
        );
      } catch {
        // Preference storage is optional; the current accessible state remains usable.
      }
    },
    [scope],
  );

  return { expanded, setExpanded: updateExpanded };
}

function readPreference(scope?: string | null): boolean {
  if (!scope) return true;
  try {
    return (
      window.localStorage.getItem(`${STORAGE_PREFIX}${scope}`) !== 'collapsed'
    );
  } catch {
    return true;
  }
}
